require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./proizvodi-oprema.json") })
        }
      }, "path---proizvodi-oprema");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---proizvodi-oprema!./.cache/json/proizvodi-oprema.json
// module id = 358
// module chunks = 231608221292675